import React, { useContext, useState } from "react";
import styled from "styled-components";
import brand from "../../../assets/sx.png";
import user2 from "../../../assets/user.png";
import logo from "../../../assets/images/logos/logo.png";
import save from "../../../assets/save.svg";
import upload from "../../../assets/upl.svg";
import account from "../../../assets/acc.svg";
import { Link, useHistory } from "react-router-dom";
import { db, auth } from "../../../firebase";
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { userContext } from "../../../App";
import ButtonGroup from '@material-ui/core/ButtonGroup';
import SignInDialog from '../Folios/SignInDialog';
import Search from './Search';
import Profile from "../Folios/Profile";
import BrandLogo from '../../../assets/images/logos/logo2.png'
import Logo from '../../../assets/images/logos/logo.png'
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import MaterialLink from '@material-ui/core/Link';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';

import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useMediaQuery,
  Button,
  useScrollTrigger,
  Slide,
  Menu,
  MenuItem,
  ListItemIcon
} from "@material-ui/core";

const SearchBar = withStyles((theme) => ({
  root: {
    "font-size": "16px",
    fontFamily: 'Rubik',
    "padding": "0 20px",
    "color": "#a6a6a6",
    "width": "520px",
    "border": "3px solid #000000",
    "border-radius": "31.5px",
    "box-sizing": "border-box",
    "height": "43px",
    '& input': {
      textAlign: "left"
    },
    '& input::placeholder': {
      textAlign: "center"
    },
    '& input:focus::placeholder': {
      color: "transparent"
    },
    '@media (max-width: 1145px)': {
      "width": "400px",
      "font-size": "15px",
    },
    '@media (max-width: 955px)': {
      "width": "300px",
      "font-size": "14px",
    },
    '@media (max-width: 815px)': {
      "width": "250px",
      "font-size": "13px",
      "height": "38px",
    },
    '@media (max-width: 510px)': {
      "width": "200px",
      "font-size": "12px",
      "padding": "0 10px",
      "height": "34px",
    },
    '@media (max-width: 415px)': {
      // "width": "155px",
      // "font-size": "10px",
      marginLeft: "5vw",
      "padding": "0 8px",
      "border": "2.4px solid #000000",
    },
  },
}))(InputBase);

const NavLink = withStyles((theme) => ({
  root: {
    "text-decoration": "none",
    display: "block",
    "color": "black",
    "font-size": "16px",
    fontFamily: 'Rubik',
    "margin": "0 30px",
    '&:hover': {
      "text-decoration": "none",
      color: "#3e6ae1",
      cursor: "pointer"
    },
    '@media (max-width: 1145px)': {
      "margin": "0 20px",
    },
    '@media (max-width: 955px)': {
      "margin": "0 15px",
    },
    '@media (max-width: 815px)': {
      "font-size": "14px",
    },
    '@media (max-width: 730px)': {
      display: "none"
    },
  },
}))(MaterialLink);

const useStyles = makeStyles((theme) => ({
  Klogo: {
    margin: "0 5px 0 30px",
    cursor: "pointer",
    width: "45px",
    height: "45px",
    '@media (max-width: 1145px)': {
      margin: "0 5px 0 20px",
    },
    '@media (max-width: 955px)': {
      margin: "0 5px 0 15px",
      width: "40px",
      height: "40px",
    },
    '@media (max-width: 815px)': {
      width: "35px",
      height: "35px",
    },
    '@media (max-width: 510px)': {
      margin: "0 5px 0 10px",
      width: "30px",
      height: "30px",
    },
    '@media (max-width: 415px)': {
      margin: "0 5px 0 15px",
      width: "40px",
      height: "40px",
    },
  },
  KredayLogo: {
    margin: "0 30px 0 5px",
    cursor: "pointer",
    width: "120px",
    height: "22.55px",
    '@media (max-width: 1145px)': {
      margin: "0 20px 0 5px",
    },
    '@media (max-width: 955px)': {
      margin: "0 15px 0 5px",
    },
    '@media (max-width: 510px)': {
      margin: "0 10px 0 5px",
      width: "90px",
      height: "17px",
    },
    '@media (max-width: 415px)': {
      display: "none"
    },
  },
  toggleIcon: {
    display: "none",
    '@media (max-width: 730px)': {
      display: "block"
    },
  },
  paper: {
    fontFamily: 'Rubik',
    marginRight: theme.spacing(0),
  },
  navbar: {
    fontFamily: 'Rubik',
    position: "fixed",
    transition: "top 0.3s",
  }
}));

const NavFront = (props) => {
  let history = useHistory();
  const [searcharr, setsearcharr] = useState();
  const [prof, setprof] = useState([]);
  const [profile, setprofile] = useState();
  const [category, setcategory] = useState("");
  const categories = [
    "agriculture",
    "anthropology",
    "architecture",
    "arthistory",
    "biology",
    "botany",
    "business",
    "design",
    "economics",
    "engineering",
    "english",
    "enterpreneurship",
    "environmentalscience",
    "fantasy",
    "fashion",
    "finearts",
    "finance",
    "food",
    "generalscience",
    "geography",
    "geology",
    "health",
    "horror",
    "humor",
    "law",
    "lifestyle",
    "literature",
    "management",
    "maths",
    "medicalscience",
    "mentalhealth",
    "music",
    "mystery",
    "nonfiction",
    "parenting",
    "personalitydevelopment",
    "philosophy",
    "physicaleducation",
    "physics",
    "poetry",
    "politicalscience",
    "psychology",
    "publicadministration",
    "romance",
    "sci-fi",
    "socialscience",
    "sociology",
    "spiritual",
    "statistics",
    "theater",
    "thriller",
    "youngadult",
    "zoology",
  ];


  const searchInput = React.useRef(null);

  const gotoHome = () => {
    if (localStorage.getItem('allowed') === '1') {
      window.location.href = '/home'
    }
    else {
      window.location.href = '/';
    }

  }

  const checkSignIn = () => {
    if (props.user === null) {
      props.setnavClick(true);
    }
  }

  const checkProfile = () => {
    if (props.user === null) {
      checkSignIn();
    }
    else {
      localStorage.setItem("profileid", JSON.stringify({ profileid: auth.currentUser.uid }));
      history.push('/user')
    }
  }

  const checkSaved = () => {
    if (props.user === null) {
      checkSignIn();
    }
    else {
      window.location.href = '/saved';
    }
  }

  const checkPublish = () => {
    if (props.user === null) {
      checkSignIn();
    }
    else {
      window.location.href = '/file';
    }
  }

  const checkSettings = () => {
    if (props.user === null) {
      checkSignIn();
    }
    else {

      history.push('/settings')
    }
  }

  if (document.activeElement === searchInput.current) {
    // console.log('open')
  }
  else {
    //console.log('closed')
  }

  const textChange = (e) => {
    let arr = [];
    let arr2 = [];
    let temparr = [];
    props.setsearchtext(e.target.value);
    const users = db.collection('users').get().then((docs) => {
      docs.forEach((doc) => {
        temparr.push({ name: doc.data().name, description: doc.data().description, profilePic: doc.data().profilePic, follower_Count: doc.data().follower_Count, id: doc.id })
      })
      setprof(temparr);
      console.log(temparr);
    });
    db.collection("posts")
      .get()
      .then((docs) => {
        prof.forEach((p) => {
          console.log(p.name, p.id, p.description, p.profilePic, p.follower_Count);
          if (p.name && p.name.replace(/ /g, "").toLowerCase().includes(e.target.value.replace(/ /g, "").toLowerCase())) {
            arr2.push({ title: p.name, tag: "Profile", type: "Profile", id: p.id })
            if (p.name.replace(/ /g, "").toLowerCase() === e.target.value.replace(/ /g, "").toLowerCase()) {
              let prof;
              if (p.profilePic !== "") {
                prof = p.profilePic;
              }
              else {
                prof = user2;
              }
              setprofile({ name: p.name, description: p.description, follower: p.follower_Count, profile_pic: prof, id: p.id });
            }
          }
        })
        categories.forEach((cat) => {
          if (cat.replace(/ /g, "").toLowerCase().includes(e.target.value.replace(/ /g, "").toLowerCase())) {
            if (cat.replace(/ /g, "").toLowerCase() === e.target.value.replace(/ /g, "").toLowerCase()) {
              setcategory(cat);
            }
            arr2.push({ title: cat, tag: "Category", type: "Category" })

          }
        })
        docs.forEach((doc) => {
          console.log(
            doc.data().title.includes(e.target.value),
            e.target.value,
            doc.data().title
          );
          if (
            doc
              .data()
              .title.toLowerCase()
              .includes(e.target.value.toLowerCase())
          ) {
            if (
              doc.data().title.toLowerCase() === e.target.value.toLowerCase()
            ) {
              props.setexacttitle(doc.data());

            } else {
              props.setexacttitle("");
            }
            //props.setsearchtype('folio');
            arr.push({ data: doc.data(), id: doc.id });
            arr2.push({ title: doc.data().title, tag: doc.data().name, type: "Folio", id: doc.id })
          }


          if (
            doc
              .data()
              .category.replace(/ /g, "").toLowerCase()
              .includes(e.target.value.replace(/ /g, "").toLowerCase())
          ) {

            props.setexacttitle("");

            arr.push({ data: doc.data(), id: doc.id });
            arr2.push({ title: doc.data().title, tag: "Folio", type: "Folio", id: doc.id })
          }

          if (
            doc
              .data()
              .name.replace(/ /g, "").toLowerCase()
              .includes(e.target.value.replace(/ /g, "").toLowerCase())
          ) {

            props.setexacttitle("");

            arr.push({ data: doc.data(), id: doc.id });
            arr2.push({ title: doc.data().title, tag: "Profile", type: "Folio", id: doc.id })
          }
        });
        console.log(prof)


        props.setsearchtitle(arr);
        setsearcharr(arr);
        props.setsearchtype(arr2);
        console.log(arr2);
      });
  };
  const keyEnter = (e) => {
    console.log(e.key);
    if (e.key === 'Enter') {
      props.setsearchClicked(true);
      props.setsearchClicked(true);
      console.log(profile);
      localStorage.setItem("search", JSON.stringify({ search: searcharr, category: category, profile: profile }));
      history.push("/searchresult");
    }
  }

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  // const useStyles = makeStyles((theme) => ({
  //   Klogo: {
  //     margin: "0 5px 0 30px",
  //     cursor: "pointer",
  //     width: "45px",
  //     height: "45px",
  //     '@media (max-width: 1145px)': {
  //       margin: "0 5px 0 20px",
  //     },

  function HideOnScroll(props) {
    const { children } = props;
    const trigger = useScrollTrigger();

    return (
      <Slide appear={false} direction={"down"} in={!trigger}>
        {children}
      </Slide>
    );
  }

  return (
    <>
      {!isMobile ? (
        <HideOnScroll {...props}>
          <Nav style={{ "font-family": "Rubik" }} className={classes.navbar}>

            <div>
              <img src={Logo} className={classes.Klogo} onClick={gotoHome} />
              <img src={BrandLogo} className={classes.KredayLogo} onClick={gotoHome} />
            </div>

            <div>
              <SearchBar
                type="text"
                style={{ outline: 'none', color: 'black', "font-family": "FontAwesome,Rubik" }}
                placeholder="&#xF002; &nbsp;Search Amazing Folios"
                value={props.searchtext}
                onChange={textChange}
                onFocus={(e) => e.target.readOnly = false}
                ref={searchInput}
                onKeyPress={keyEnter}
                readOnly
              />
            </div>

            <div>
              <ButtonGroup>
                {/* <NavLink onClick={checkSignIn}>
  Chats
</NavLink> */}
                <NavLink id="navlink" onClick={checkProfile}>
                  My Profile
                </NavLink>

                <NavLink id="navlink" onClick={checkSaved}>
                  Saved
                </NavLink>

                <NavLink id="navlink" onClick={checkPublish}>
                  Publish
                </NavLink>

                <NavLink id="navlink" onClick={checkSettings}>
                  Settings
                </NavLink>

              </ButtonGroup>
            </div>

            {/* <IconButton
          color="textPrimary"
          className={classes.menuButton}
          edge="start"
          aria-label="menu"
          // aria-controls={open ? 'menu-list-grow' : undefined}
          // aria-haspopup="true"
          onClick={handleToggle}
        >
          <MenuRoundedIcon />
        </IconButton>

        <Menu
          id="menu-appbar"
          anchorEl={anchorRef.current}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          KeepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={open}
        >

          <MenuItem >
            <Typography variant="h6"> My Profile </Typography>
          </MenuItem>
          <MenuItem >
            <Typography variant="h6"> Saved </Typography>
          </MenuItem>
          <MenuItem >
            <Typography variant="h6"> Publish </Typography>
          </MenuItem>
          <MenuItem >
            <Typography variant="h6"> Settings </Typography>
          </MenuItem>

        </Menu> */}

            <div className={classes.toggleIcon} >
              <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
              >
                <MenuRoundedIcon />
              </Button>
              <Popper open={open} role={undefined} transition disablePortal style={{ top: "85px", left: "calc(100% - 110px)" }} >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                          <MenuItem onClick={checkProfile}>
                            My Profile
                          </MenuItem>

                          <MenuItem onClick={checkSaved}>
                            Saved
                          </MenuItem>

                          <MenuItem onClick={checkPublish}>
                            Publish
                          </MenuItem>

                          <MenuItem onClick={checkSettings}>
                            Settings
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>


            {/* <ButtonGroup>
<NavLink onClick={checkSignIn} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Chats
</NavLink>
<NavLink onClick={checkProfile} style={{
textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer'
}}>
My Profile
</NavLink>
<NavLink onClick={checkSaved} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Saved
</NavLink>
<NavLink onClick={checkPublish} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Publish
</NavLink>
<NavLink onClick={checkSettings} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Settings
</NavLink>
</ButtonGroup> */}

            {/* <Button>Login</Button> */}


            {/* </BrandName> */}
            {/* <div>
<span> </span>
<SearchBar
type="text"
placeholder="&#xF002; &nbsp; &nbsp; Search Amazing Folios"
style={{ outline: 'none', color: 'black' }}
value={props.searchtext}
onChange={textChange}
onFocus={(e) => e.target.readOnly = false}
ref={searchInput}
onKeyPress={keyEnter}
readOnly
/>

</div> */}
            {/* <div style={{ position: 'absolute', marginLeft: '60vw' }}>
<ButtonGroup>
<Link onClick={checkSignIn} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '9vw', cursor: 'pointer' }}>
Chats
</Link>
<Link onClick={checkProfile} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '13vw', cursor: 'pointer' }}>
My Profile
</Link>
<Link onClick={checkSaved} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '2vw', cursor: 'pointer' }}>
Saved
</Link>
<Link onClick={checkPublish} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '2vw', cursor: 'pointer' }}>
Publish
</Link>
<Link onClick={checkSettings} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '2vw', cursor: 'pointer' }}>
Settings
</Link>
</ButtonGroup>
</div> */}
          </Nav >
        </HideOnScroll >
      ) : (<>
        <Nav style={{ "font-family": "Rubik" }} className={classes.navbar}>

          <div>
            <img src={Logo} className={classes.Klogo} onClick={gotoHome} />
            <img src={BrandLogo} className={classes.KredayLogo} onClick={gotoHome} />
          </div>

          <div>
            <SearchBar
              type="text"
              style={{ outline: 'none', color: 'black', "font-family": "FontAwesome,Rubik" }}
              placeholder="&#xF002; &nbsp;Search Amazing Folios"
              value={props.searchtext}
              onChange={textChange}
              onFocus={(e) => e.target.readOnly = false}
              ref={searchInput}
              onKeyPress={keyEnter}
              readOnly
            />
          </div>

          <div>
            <ButtonGroup>
              {/* <NavLink onClick={checkSignIn}>
Chats
</NavLink> */}
              <NavLink id="navlink" onClick={checkProfile}>
                My Profile
              </NavLink>

              <NavLink id="navlink" onClick={checkSaved}>
                Saved
              </NavLink>

              <NavLink id="navlink" onClick={checkPublish}>
                Publish
              </NavLink>

              <NavLink id="navlink" onClick={checkSettings}>
                Settings
              </NavLink>

            </ButtonGroup>
          </div>

          {/* <IconButton
  color="textPrimary"
  className={classes.menuButton}
  edge="start"
  aria-label="menu"
  // aria-controls={open ? 'menu-list-grow' : undefined}
  // aria-haspopup="true"
  onClick={handleToggle}
>
  <MenuRoundedIcon />
</IconButton>

<Menu
  id="menu-appbar"
  anchorEl={anchorRef.current}
  anchorOrigin={{
    vertical: "top",
    horizontal: "right"
  }}
  KeepMounted
  transformOrigin={{
    vertical: "top",
    horizontal: "right"
  }}
  open={open}
>

  <MenuItem >
    <Typography variant="h6"> My Profile </Typography>
  </MenuItem>
  <MenuItem >
    <Typography variant="h6"> Saved </Typography>
  </MenuItem>
  <MenuItem >
    <Typography variant="h6"> Publish </Typography>
  </MenuItem>
  <MenuItem >
    <Typography variant="h6"> Settings </Typography>
  </MenuItem>

</Menu> */}

          <div className={classes.toggleIcon} >
            <Button
              ref={anchorRef}
              edge="start"
              aria-label="menu"
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
            >
              <MenuRoundedIcon />
            </Button>
            <Popper open={open} role={undefined} transition disablePortal style={{ top: "85px", left: "calc(100% - 110px)" }} >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                        <MenuItem onClick={checkProfile}>
                          My Profile
                        </MenuItem>

                        <MenuItem onClick={checkSaved}>
                          Saved
                        </MenuItem>

                        <MenuItem onClick={checkPublish}>
                          Publish
                        </MenuItem>

                        <MenuItem onClick={checkSettings}>
                          Settings
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>


          {/* <ButtonGroup>
<NavLink onClick={checkSignIn} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Chats
</NavLink>
<NavLink onClick={checkProfile} style={{
textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer'
}}>
My Profile
</NavLink>
<NavLink onClick={checkSaved} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Saved
</NavLink>
<NavLink onClick={checkPublish} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Publish
</NavLink>
<NavLink onClick={checkSettings} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', cursor: 'pointer' }}>
Settings
</NavLink>
</ButtonGroup> */}

          {/* <Button>Login</Button> */}


          {/* </BrandName> */}
          {/* <div>
<span> </span>
<SearchBar
type="text"
placeholder="&#xF002; &nbsp; &nbsp; Search Amazing Folios"
style={{ outline: 'none', color: 'black' }}
value={props.searchtext}
onChange={textChange}
onFocus={(e) => e.target.readOnly = false}
ref={searchInput}
onKeyPress={keyEnter}
readOnly
/>

</div> */}
          {/* <div style={{ position: 'absolute', marginLeft: '60vw' }}>
<ButtonGroup>
<Link onClick={checkSignIn} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '9vw', cursor: 'pointer' }}>
Chats
</Link>
<Link onClick={checkProfile} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '13vw', cursor: 'pointer' }}>
My Profile
</Link>
<Link onClick={checkSaved} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '2vw', cursor: 'pointer' }}>
Saved
</Link>
<Link onClick={checkPublish} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '2vw', cursor: 'pointer' }}>
Publish
</Link>
<Link onClick={checkSettings} style={{ textDecoration: 'none', color: 'black', lineHeight: '12vh', marginLeft: '2vw', cursor: 'pointer' }}>
Settings
</Link>
</ButtonGroup>
</div> */}
        </Nav >
      </>)}
    </>



  );
};

// ========================Styling Components============================================
const Nav = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 20%);
  flex-direction: row;
  z-index: 1;
  overflow-x: hidden;
  width: 100%;
  height: 85px;
  justify-content: space-between;
`;


// const SearchBar = styled.input`
//     font-size: 16px;
//     font-family: 'Rubik';
//     padding: 0 20px;
//     color: #a6a6a6;
//     width: 520px;
//     border: 3px solid #000000;
//     border-radius: 31.5px;
//     box-sizing: border-box;
//     height: 43px;
//     & input{
//       text-align: left;
//     };
//     & input::placeholder{
//       text-align: center;
//     };
//     & input:focus::placeholder{
//       color: transparent;
//     };
//     @media (max-width: 1145px){
//       width: 400px;
//       font-size: 15px;
//     };
//     @media (max-width: 955px){
//       width: 300px;
//       font-size: 14px;
//     };
//     @media (max-width: 815px){
//       width: 250px;
//       font-size: 13px;
//       height: 38px;
//     };
//     @media (max-width: 510px){
//       width: 200px;
//       font-size: 12px;
//       padding: 0 10px;
//       height: 34px;
//     };
//     @media (max-width: 415px){
//       // width: 155px;
//       // font-size: 10px;
//       marginLeft: 5vw;
//       padding: 0 8px;
//       border: 2.4px solid #000000;
//     };
// `



// const BrandName = styled.div`
//   display: flex;
//   flex-direction: row;
// `;
// const KredayLogo = styled.img.attrs({
//   src: brand,
// })`
//   width: 120px;
//   height: 21.45px;
//   // position: relative;
//   // left: 45px;
//   // top: 35.75px;
//   cursor: pointer;
// `;

// const Klogo = styled.img.attrs({
//   src: logo,
// })`
//   // position: relative;
//   width: 45px;
//   height: 45px;
//   // left: 50px;
//   // top: 25px;
//   cursor: pointer;
// `;

// const SearchBar = styled.input.attrs((props) => ({
//   type: "text",
// }))`
//   // position: absolute;
//   ::-webkit-input-placeholder {
//     font-family: Rubik, FontAwesome;
//   }
//   // top: 3vh;
//   // left: 32vw;
//   font-size: 16px;
//   // text-align: center;
//   padding: 0 20px;
//   color: #a6a6a6;
//   width: 520px;
//   border: 3px solid #000000;
//   border-radius: 31.5px;
//   box-sizing: border-box;
//   height: 43px;
// `;

// export { SearchBar };

export default NavFront;
